import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { CopyToClipboard } from 'react-copy-to-clipboard'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import { parseOpenHours } from '@libs/placeHelper'
import { trackingShareProperty } from '@app-core/beacon/beacon'
import { imageAssetUrl, openPlaceInRNMap, openPost } from '@libs/appUrl'

import { PlaceType } from '@app-core/place/reducer'

import { compose, getContext, withBeacon, withTranslation } from '@hocs'

import styles from './PlaceInfo.scss'
import { CouponCard } from './CouponCard'

class PlaceInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openNow: false,
      openHourText: '',
      showOpenHours: false,
    }
  }

  _generateOpenHoursText = (openHours) => {
    const { t } = this.props
    const { openNow, openHourText, openDay } = parseOpenHours(openHours, t)
    this.setState({
      openNow,
      openHourText,
      openDay,
      showOpenHours: true,
    })
  }

  _onClapClicked = () => {
    const { openCommentPop } = this.props
    openCommentPop({ via: 'total.claps' })
  }

  _onAddrCopied = () => {
    const { t, placeData, amplitudeEventTrack } = this.props
    window.alert(t('已複製至剪貼簿'))
    amplitudeEventTrack('click.copy.address', trackingShareProperty(placeData))
  }

  _onClickedRNMap = () => {
    const { placeData, amplitudeEventTrack } = this.props
    openPlaceInRNMap(placeData)
    amplitudeEventTrack('click.open.address', trackingShareProperty(placeData))
  }

  _onClickedUnlock = () => {
    const { placeData, amplitudeEventTrack } = this.props
    openPlaceInRNMap(placeData)
    amplitudeEventTrack('click.unlock.nearby.places', trackingShareProperty(placeData))
  }

  _onClickedGhostQuestionMark = () => {
    const { openMessageDialog, placeData, t, amplitudeEventTrack } = this.props
    amplitudeEventTrack('click.description.info', trackingShareProperty(placeData))
    openMessageDialog({
      title: t('網路資料'),
      message: t('此處的內容為網路擷取資料，可能出現時效問題或是錯誤，僅提供參考。'),
    })
  }

  get couponLink() {
    const { giftId } = this.props
    return giftId ? `/popcoupon/${giftId}` : '#'
  }

  _onClickedCoupon = () => {
    const { amplitudeEventTrack, giftData } = this.props
    amplitudeEventTrack('get.coupon', trackingShareProperty(giftData, { via: 'place' }))
    openPost(this.couponLink)
  }

  _onClickedOpenHours = () => {
    const { openOpenHoursPop, placeData, amplitudeEventTrack } = this.props
    openOpenHoursPop({
      openHoursText: placeData.getIn(['place', 'openHoursText']).toJS(),
      openDay: this.state.openDay,
    })
    amplitudeEventTrack('click.business.hour', trackingShareProperty(placeData))
  }

  _onClickedPhone = () => {
    const { placeData, amplitudeEventTrack } = this.props
    amplitudeEventTrack('click.call', trackingShareProperty(placeData))
  }

  componentDidMount() {
    const openHours = this.props.placeData.getIn(['place', 'openHours'])
    if (openHours) {
      this._generateOpenHoursText(openHours.toJS())
    }
  }

  render() {
    const { placeType, t, hasGift, giftId } = this.props
    const place = this.props.placeData.get('place').toJS()
    return (
      <div className="place__info info">
        <style jsx>{styles}</style>
        <div className="info__spaceBetween">
          <h1 className="info__name">{place.name}</h1>
        </div>
        {placeType === PlaceType.choice && (
          <>
            <div className="info__spaceBetween info__subtitle">
              <div className="info__subtitle__left">
                <div className="info__clap" onClick={this._onClapClicked}>
                  <span className="info__clapScore">{place.clap && place.clap.score}</span>
                </div>
                <div className="info__subtitle__item">{`${t('均消')} ${place.priceRange} / ${t(
                  '每人',
                )}`}</div>
                {place.tag && <div className="info__subtitle__item">{place.tag[0]}</div>}
              </div>
            </div>
            {hasGift && (
              <CouponCard onClick={this._onClickedCoupon} giftId={giftId} link={this.couponLink} />
            )}
          </>
        )}
        {place.addr && (
          <div className="info__detailRow info__addr">
            <div className="info__spaceBetween info__verticalRightBorder">
              <CopyToClipboard text={place.addr} onCopy={this._onAddrCopied}>
                <div className="info__detailTextWrapper">
                  <h3 className="info__detailTitle">{t('地址')}</h3>
                  <p className="info__detailContent">{place.addr}</p>
                </div>
              </CopyToClipboard>
            </div>
            <div className="info__rnMapBtn" onClick={this._onClickedRNMap} />
          </div>
        )}
        {this.state.showOpenHours && (
          <div
            className="info__spaceBetween info__detailRow info__pointer"
            onClick={this._onClickedOpenHours}
          >
            <div className="info__detailTextWrapper">
              <h3 className="info__detailTitle">{t('時間')}</h3>
              <p
                className={`info__detailContent info__openStatus--${
                  this.state.openNow ? 'open' : 'close'
                }`}
              >
                {this.state.openHourText}
              </p>
            </div>
            <div className="info__detailAccessory" />
          </div>
        )}
        {place.phone && (
          <div className="info__spaceBetween info__detailRow">
            <a href={'tel:' + place.phone} onClick={this._onClickedPhone}>
              <div className="info__detailTextWrapper">
                <h3 className="info__detailTitle">{t('電話')}</h3>
                <p className="info__detailContent">{place.phone}</p>
              </div>
              <div className="info__detailAccessory" />
            </a>
          </div>
        )}
        {place.tip && (
          <div className="info__spaceBetween info__detailRow">
            <div className="info__detailTextWrapper">
              <h3 className="info__detailTitle">{t('提醒')}</h3>
              <p className="info__detailContent">{place.tip}</p>
            </div>
          </div>
        )}
        {place.item && (
          <div className="info__spaceBetween info__detailRow">
            <div className="info__detailTextWrapper">
              <h3 className="info__detailTitle">{t('價格')}</h3>
              <p className="info__detailContent">{place.item}</p>
            </div>
          </div>
        )}
        {place.comment && (
          <div className="info__spaceBetween info__detailRow">
            <div className="info__detailTextWrapper">
              {placeType === PlaceType.choice ? (
                <h3 className="info__detailTitle">{t('波波推薦')}</h3>
              ) : (
                <div className="info__detailTitle info__ghostComment">
                  <h3>{t('網路資料')}</h3>
                  <img
                    className="info__ghostQuestion"
                    onClick={this._onClickedGhostQuestionMark}
                    src={imageAssetUrl('icon/question@3x.png')}
                  />
                </div>
              )}
              <p className="info__detailContent">{place.comment}</p>
            </div>
          </div>
        )}
        {placeType === PlaceType.ghost && (
          <div className="info__spaceBetween info__gray">
            <div className="info__ghostRNMapBtn" onClick={this._onClickedUnlock}>
              {t('點我解鎖，查看附近精選地點')}
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default compose(
  withBeacon,
  withTranslation(),
  getContext({
    hasGift: PropTypes.bool.isRequired,
    giftId: PropTypes.string,
    placeType: PropTypes.string.isRequired,
    openMessageDialog: PropTypes.func.isRequired,
  }),
)(PlaceInfo)
